import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function FinalCTA() {
  return (
    <section
      data-testid="final-cta-section"
      id="final-cta"
      className="relative py-24 md:py-32 bg-white border-t border-slate-200/60 overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[420px] w-[860px] bg-[#3B82F6]/10 blur-[120px] rounded-full" />
      </div>
      <motion.div
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.55 }}
        className="relative max-w-3xl mx-auto px-6 text-center"
      >
        <p className="font-inter text-[11px] font-bold tracking-[0.22em] uppercase text-[#3B82F6]">
          Get Started
        </p>
        <h2 className="mt-4 font-display text-4xl md:text-[52px] font-extrabold tracking-[-0.02em] text-[#0B1F3A] leading-[1.05]">
          Launch One Bidding Request.<br />
          <span className="text-[#475569]">Award With Confidence.</span>
        </h2>
        <p className="mt-6 text-[15px] md:text-base text-[#475569] leading-relaxed max-w-xl mx-auto">
          Invite verified manufacturers, receive competitive factory offers and manage
          the entire procurement bidding process inside one Workspace.
        </p>
        <div className="mt-9 flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/workspace"
            data-testid="final-cta-primary"
            className="group inline-flex items-center justify-center gap-2 bg-[#0B1F3A] hover:bg-[#0B1F3A]/92 text-white text-[15px] font-medium px-6 py-3.5 rounded-xl shadow-sm transition-all hover:shadow-lg hover:translate-y-[-1px]"
          >
            Launch CommodityBid™️
            <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
          <Link
            to="/workspace"
            data-testid="final-cta-secondary"
            className="inline-flex items-center justify-center gap-2 bg-white hover:bg-slate-50 text-[#0B1F3A] border border-slate-200 text-[15px] font-medium px-6 py-3.5 rounded-xl shadow-sm transition-all"
          >
            Create Your Free Workspace
          </Link>
        </div>

        <p className="mt-8 text-[12.5px] text-[#64748B] flex flex-col sm:flex-row items-center justify-center gap-x-3 gap-y-1.5">
          <span className="inline-flex items-center gap-1.5">
            <span className="h-1 w-1 rounded-full bg-emerald-500" />
            Buy directly from manufacturers
          </span>
          <span className="hidden sm:inline text-slate-300">·</span>
          <span className="inline-flex items-center gap-1.5">
            <span className="h-1 w-1 rounded-full bg-emerald-500" />
            Factory Direct Offers
          </span>
          <span className="hidden sm:inline text-slate-300">·</span>
          <span className="inline-flex items-center gap-1.5">
            <span className="h-1 w-1 rounded-full bg-emerald-500" />
            No Product Markups
          </span>
        </p>
      </motion.div>
    </section>
  );
}
